<template>
  <metabase-dashboard :dashboard-id="DASHBOARD_ID" :title="t('Provider Performance Report')" />
</template>

<script>
import MetabaseDashboard from '@/components/metabase/MetabaseDashboard.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

const DASHBOARD_ID = 10;

export default {
  name: 'ProviderPerformanceReport',

  components: {
    MetabaseDashboard
  },

  data() {
    return {
      DASHBOARD_ID
    };
  },

  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>
